import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

import { runtimeEnv } from '../runtimeEnv';

const config: Configuration = {
  auth: {
    clientId: runtimeEnv.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${runtimeEnv.AZURE_TENANT_ID}`,
    redirectUri: runtimeEnv.AZURE_REDIRECT_URI || window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage' },
};

export const msalInstance = new PublicClientApplication(config);

export const apiScopes: string[] = [runtimeEnv.AZURE_API_SCOPE];

// Osobny scope na Microsoft Graph: MSAL wydaje token per resource, więc token do
// własnego API nie zadziała na `graph.microsoft.com`. Puste = funkcja draftów
// mailowych jest wyłączona (zgoda administratora tenanta na `Mail.ReadWrite`
// bywa niedostępna, a raport musi działać bez niej).
export const graphMailScopes: string[] = runtimeEnv.AZURE_GRAPH_MAIL_SCOPE
  ? [runtimeEnv.AZURE_GRAPH_MAIL_SCOPE]
  : [];

// Scope na pliki (zapis rozliczeń w bibliotece SharePoint). Osobny od poczty,
// bo to osobna funkcja i osobna zgoda: środowisko może mieć jedną bez drugiej,
// a MSAL i tak wydaje token per zestaw uprawnień. Puste = przycisk zapisu ukryty.
export const graphFilesScopes: string[] = runtimeEnv.AZURE_GRAPH_FILES_SCOPE
  ? [runtimeEnv.AZURE_GRAPH_FILES_SCOPE]
  : [];
